import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { MenuStack } from "./Styles";
import { COLORS } from "../../constants";
import { useSelector } from "react-redux";
import { deleteExercise, moveExercise, toggleRocket } from "./Functions/FunctionsManipulateExercises";
import { RootState } from "../..";
import { ExerciseInterface } from "../../interfaces/examInterfaces";

export const ExerciseMenu = ({
  index,
  amountExercises,
  showRocket,
  sortedExercises,
  zoomFactor,
}: {
  index: number;
  amountExercises: number;
  showRocket: boolean;
  sortedExercises: ExerciseInterface[];
  zoomFactor: number;
}) => {
  const selectedObjectiveId = useSelector((state: RootState) => state.examBuilder.main.selectedObjectiveId);
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);

  function moveExerciseUp(index: number) {
    if (selectedObjectiveId) {
      const newExerciseIndex = index - 1;
      moveExercise(index, newExerciseIndex, sortedExercises, selectedObjectiveId, examData);
    }
  }

  function moveExerciseDown(index: number) {
    if (selectedObjectiveId) {
      const newExerciseIndex = index + 1;
      moveExercise(index, newExerciseIndex, sortedExercises, selectedObjectiveId, examData);
    }
  }

  function handleToggleRocket(index: number) {
    if (selectedObjectiveId) {
      toggleRocket(index, sortedExercises, selectedObjectiveId, examData);
    }
  }

  function handleDeleteExercise(index: number) {
    if (selectedObjectiveId) {
      deleteExercise(index, sortedExercises, selectedObjectiveId, examData);
    }
  }

  return (
    <>
      <MenuStack direction="column" zoomfactor={zoomFactor}>
        {index > 0 && (
          <Tooltip title="Auf" placement="right">
            <IconButton aria-label="up" onClick={() => moveExerciseUp(index)}>
              <KeyboardArrowUpIcon />
            </IconButton>
          </Tooltip>
        )}
        {index + 1 !== amountExercises && (
          <Tooltip title="Ab" placement="right">
            <IconButton aria-label="down" onClick={() => moveExerciseDown(index)}>
              <KeyboardArrowDownIcon />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="Schwierige Aufgabe" placement="right">
          <IconButton aria-label="rocket" onClick={() => handleToggleRocket(index)}>
            <RocketLaunchIcon sx={{ color: showRocket === true ? COLORS.DIDACTO_DARK_RED : "auto" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Löschen" placement="right">
          <IconButton aria-label="delete" onClick={() => handleDeleteExercise(index)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </MenuStack>
    </>
  );
};

export default ExerciseMenu;
